import {toggleMark} from "tiptap-commands/src";
import { Mark } from 'tiptap';

export default class FontSizeExtension extends Mark {
    get name() {
        return "fontSize";
    }

    get schema() {
        return {
            attrs: {
                fontSize: {
                    default: "12px",
                },

            },
            parseDOM: [
                {
                    style: 'font-size',
                    getAttrs: value => ({fontSize: value})
                },
            ],
            toDOM: mark => ["span",
                {style: `font-size: ${mark.attrs.fontSize};`
                }, 0]
        };
    }

    commands({ type }) {
        return attrs => toggleMark(type, attrs);
    }

}